import React from 'react';

const CTA = () => {
  return (
    <section 
      className="py-24 relative overflow-hidden bg-white"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-5xl font-bold text-primary mb-8 tracking-tight">
          Siap Menyelesaikan Pekerjaan Akademik?
        </h2>
        <p className="text-xl text-secondary mb-12 max-w-2xl mx-auto font-medium leading-relaxed">
          Bergabunglah dengan ribuan akademisi yang telah mempercayakan urusan teknis mereka kepada tim profesional kami.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-primary text-white px-10 py-4 rounded-xl font-semibold text-lg hover:opacity-90 transition-all shadow-lg">
            Mulai Konsultasi
          </button>
          <button className="border-2 border-divider text-primary px-10 py-4 rounded-xl font-semibold text-lg hover:bg-divider transition-all">
            Hubungi Kami
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;